import React from 'react'
import clsx from 'clsx'
import { FormProvider, useForm } from 'react-hook-form'
import { Box, Typography } from '@mui/material'
import { Card } from 'src/components/atoms'
import SelectWithOption from 'src/components/molecules/SelectWithOption'
import { TenantDetailsPostRequestTenant } from 'src/slices/services/api'
import commonStyles from '../../common.module.scss'
import { convertReportCycleToValue, reportCycleOption } from '../../constants'
import { ReportCycleEnum, TenantFormTypes } from '../../type'
import styles from './styles.module.scss'

export type TenantFormProps = {
  tenant?: TenantDetailsPostRequestTenant
  onChange: (tenant: TenantDetailsPostRequestTenant) => void
} & React.StyledProps

const TenantForm: React.StyledFC<TenantFormProps> = ({
  className,
  tenant,
  onChange,
}: TenantFormProps) => {
  const formMethods = useForm<TenantFormTypes>({
    defaultValues: {
      reportCycle: convertReportCycleToValue(tenant?.isMonthlyReport),
    },
    mode: 'onChange',
  })

  return (
    <FormProvider {...formMethods}>
      <Box className={clsx(className, styles.root)}>
        <Box className={commonStyles.leftColumn}>
          <Box className={commonStyles.leftCard}>
            <Card className={commonStyles.cardTitle} title="売上報告">
              <Box className={styles.container}>
                <Typography component="h3" className={styles.label}>
                  報告サイクル
                </Typography>
                <SelectWithOption
                  className={styles.select}
                  options={reportCycleOption}
                  defaultValue={convertReportCycleToValue(
                    tenant?.isMonthlyReport
                  )}
                  name="reportCycle"
                  variant="outlined"
                  placeholder=""
                  onChange={(tenantForm) => {
                    onChange({
                      isMonthlyReport:
                        tenantForm.value === ReportCycleEnum.isMonthlyReport,
                    })
                  }}
                />
              </Box>
            </Card>
          </Box>
        </Box>
        <Box className={commonStyles.rightColumn} />
      </Box>
    </FormProvider>
  )
}

export default TenantForm
